/**
 * Anchor Link Fix for Page Transitions
 * 修复页面转换功能对带锚点链接的处理问题
 * 
 * 问题：页面转换会拦截所有链接（除了以#开头的），包括跨页面锚点链接如 /pages/about#section
 * 解决：检测带锚点的链接，使用 scrollIntoView 正确处理锚点定位
 */

(function() {
  'use strict';
  
  // 等待DOM加载完成
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
  
  function init() {
    // 监听页面加载完成后的锚点处理
    window.addEventListener('load', function() {
      handleAnchorOnLoad();
    });
    
    // 处理通过pushState/replaceState导航后的锚点
    window.addEventListener('popstate', function() {
      setTimeout(handleAnchorOnLoad, 100);
    });
  }
  
  /**
   * 处理页面加载后的锚点定位
   */
  function handleAnchorOnLoad() {
    const hash = window.location.hash;
    
    if (!hash || hash === '#') {
      return;
    }
    
    try {
      // 移除 # 号
      const targetId = hash.slice(1);
      const targetElement = document.getElementById(targetId);
      
      if (targetElement) {
        // 等待一小段时间确保页面完全加载
        setTimeout(function() {
          // 使用smooth scroll如果支持
          if ('scrollBehavior' in document.documentElement.style) {
            targetElement.scrollIntoView({
              behavior: 'smooth',
              block: 'start'
            });
          } else {
            // 降级方案
            targetElement.scrollIntoView(true);
          }
          
          // 添加焦点（改善可访问性）
          if (targetElement.hasAttribute('tabindex')) {
            targetElement.focus();
          } else {
            targetElement.setAttribute('tabindex', '-1');
            targetElement.focus();
            // 防止outline持续显示
            targetElement.style.outline = 'none';
          }
        }, 300);
      } else {
        console.warn('Anchor target not found:', hash);
      }
    } catch (e) {
      console.error('Error handling anchor link:', e);
    }
  }
  
  /**
   * 为导航菜单中的锚点链接添加 no-transition 类
   * 这样页面转换就不会拦截它们
   */
  function addNoTransitionToAnchorLinks() {
    // 查找所有菜单中的链接
    const menuContainers = [
      '.header__links',
      '.drawer-menu',
      '.mega-menu',
      'nav'
    ];
    
    menuContainers.forEach(function(selector) {
      const containers = document.querySelectorAll(selector);
      
      containers.forEach(function(container) {
        const links = container.querySelectorAll('a[href*="#"]');
        
        links.forEach(function(link) {
          const href = link.getAttribute('href');
          
          // 检查是否是跨页面锚点链接 (不是以#开头的包含#的链接)
          if (href && href.includes('#') && !href.startsWith('#') && !href.startsWith('javascript:')) {
            // 添加 no-transition 类，防止页面转换拦截
            link.classList.add('no-transition');
          }
        });
      });
    });
  }
  
  // 初始运行
  addNoTransitionToAnchorLinks();
  
  // 监听DOM变化，处理动态添加的链接
  if (typeof MutationObserver !== 'undefined') {
    const observer = new MutationObserver(function(mutations) {
      let shouldReprocess = false;
      
      mutations.forEach(function(mutation) {
        if (mutation.addedNodes.length > 0) {
          mutation.addedNodes.forEach(function(node) {
            if (node.nodeType === 1) { // Element node
              if (node.tagName === 'A' || node.querySelector) {
                shouldReprocess = true;
              }
            }
          });
        }
      });
      
      if (shouldReprocess) {
        addNoTransitionToAnchorLinks();
      }
    });
    
    observer.observe(document.body, {
      childList: true,
      subtree: true
    });
  }
  
  console.log('Anchor link fix initialized');
})();

